import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { ManagerSettings } from '../../../models/employee/ManagerSettings';
import { EmployeeManagerSettingsResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts manager settings HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class ManagerSettingsAdapter implements Adapter<ManagerSettings[]> {

  /**
   * Converts manager settings HTTP response to a list of {@link ManagerSettings}.
   * @param item manager settings HTTP response.
   */
  adapt(item: EmployeeManagerSettingsResponse[]): ManagerSettings[] {
    if (!item) {
      return [];
    }

    const result: ManagerSettings[] = [];
    item.forEach($item => result.push(new ManagerSettings($item.date, $item.canDoSales)));
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
